// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 133) return "static/chunks/133-f4ee199281b8a41c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"cbb3913b5c9fdd0c","298":"3c17f9a45cf5b456","340":"e98b83c7b333b68e","367":"4411bd288cb5a6b4","639":"662b2e7c337118a6","748":"173e96a22a63bced"}[chunkId] + ".js";
};